import React, { Component } from 'react'
import heartbeatApi from '../apis/heartbeat.api'
import Label, { LabelType } from './Label'
import Tooltip from './Tooltip/Tooltip'
import { i18n } from '../i18n/i18n'

type NetworkIndicatorStatus = 'online' | 'offline'
type NetworkStates = Record<NetworkIndicatorStatus, NetworkStateData>

interface NetworkIndicatorProps {
}

interface NetworkStateData {
    type: LabelType
    text: string
    tooltip: string
}

interface NetworkIndicatorState {
    status: NetworkIndicatorStatus
}

export default class NetworkIndicator
  extends Component<NetworkIndicatorProps, NetworkIndicatorState> {
  heartbeatTimeout: number = 0

  networkStates: NetworkStates = {
    online: {
      type: 'success',
      text: `${i18n('Online')}`,
      tooltip: `${i18n('Connected to internet')}`
    },
    offline: {
      type: 'danger',
      text: `${i18n('Offline')}`,
      tooltip: `${i18n('No internet connection')}`
    }
  }

  constructor (props: NetworkIndicatorProps) {
    super(props)
    this.state = {
      status: 'online'
    }
  }

  get networkState () {
    return this.networkStates[this.state.status]
  }

  runHeartbeat = () => {
    this.heartbeatTimeout = window.setTimeout(() => {
      heartbeatApi.heartbeat(status => {
        this.setState({
          status: status ? 'online' : 'offline'
        }, this.runHeartbeat)
      })
    }, 5000)
  }

  stopHeartbeat () {
    window.clearTimeout(this.heartbeatTimeout)
  }

  componentDidMount () {
    // this.runHeartbeat()
  }

  componentWillUnmount () {
    this.stopHeartbeat()
  }

  render () {
    return (
            <Tooltip text={this.networkState.tooltip}>
                <Label
                    type={this.networkState.type}
                    text={this.networkState.text}
                    size="large"/>
            </Tooltip>
    )
  }
}
